import { useOutletContext } from "react-router";
import type { ContentVersion } from "../../../api/content/workflowsApi";
import type { LoadState } from "../../../shared/loading/useLoad";

/** What the Data model page hands its pages: the chosen project and the model versions its
 * header loaded for the version picker, so the terms and their checks resolve the same version. */
export interface DataModelContext {
  readonly projectId: string;
  /** The project's model versions, newest first. */
  readonly versions: LoadState<readonly ContentVersion[]>;
  readonly reloadVersions: () => void;
  /** The commit the address names; `null`: the latest. */
  readonly chosenVersion: string | null;
  /** A listed version's name for people: its release number, else its date (F77). */
  readonly versionName: (version: ContentVersion) => string;
  /** The terms a failing check of the shown version names, marked in the trees; `null`
   * until its checks have run. */
  readonly failingTerms: ReadonlySet<string> | null;
}

export function useDataModel(): DataModelContext {
  return useOutletContext<DataModelContext>();
}
